import { DefaultFooter } from "@ant-design/pro-components";
import React from "react";

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: "none",
      }}
      copyright="Powered by NewFMEA"
      links={[
        {
          key: "NewFMEA",
          title: "NewFMEA",
          href: "https://ai.newfmea.com",
          blankTarget: true,
        },
      ]}
    />
  );
};

export default Footer;
